import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {NoAccessState} from '@/components/no-access-state'
import {BateriaSolicitudesSection} from '@/components/bateria/bateria-solicitudes-section'
import {useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'

export function AdminBateriaSolicitudesPage() {
  const {t} = useTranslation()
  const isSystemUser = useIsSystemUser()

  if (!isSystemUser) return <NoAccessState />

  return (
    <div className="space-y-5" data-testid="admin-bateria-solicitudes">
      <PageHeading title={t('bateriaSolicitudes.admin.title')} />
      <BateriaSolicitudesSection variant="standalone" />
    </div>
  )
}
